import { render, staticRenderFns } from "./RegisterOnlineSuccess.vue?vue&type=template&id=54612cc0&"
import script from "./RegisterOnlineSuccess.vue?vue&type=script&lang=js&"
export * from "./RegisterOnlineSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports